import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Tooltip, Typography } from "@mui/material";
import { common } from "@mui/material/colors";
import { alpha } from "@mui/material/styles";

import { cmpBaseColors } from "../../../cmpBaseColors";

export const PresentationModeTooltip = () => (
  <Stack
    spacing={1}
    direction="row"
    sx={{
      alignItems: "center",
      bgcolor: cmpBaseColors.presentationModeOrange,
      color: alpha(common.black, 0.87),
      borderRadius: 1,
      pr: 1,
      pt: 0.25,
      pb: 0.25,
      pl: 1,
      position: "relative",
      zIndex: 100,
    }}
  >
    <Typography variant="subtitle2" color="inherit" noWrap>
      Demo data
    </Typography>
    <Tooltip
      placement="right"
      title="Content on this page is demo data. To see your own data, start a 45 day free trial."
    >
      <InfoOutlinedIcon sx={{ fontSize: 14 }} color="inherit" />
    </Tooltip>
  </Stack>
);
